import { FC } from 'react';

import { Button, Grid, Heading, Icon, Stack, Text } from '@eluve/components';

import { useAppointmentParams } from '../useAppointmentParams';

import { GoldenSummaryFactForm } from './GoldenSummaryFactForm';
import { useGoldenSummaryFacts } from './useSummaryFacts';

export const GoldenSummaryFactsList: FC = () => {
  const { tenantId, appointmentId } = useAppointmentParams();
  const {
    facts,
    loading,
    isCreating,
    isUpdating,
    isDeleting,
    handleAddNewFact,
    handleFactUpdate,
    handleFactDelete,
  } = useGoldenSummaryFacts(tenantId, appointmentId);

  return (
    <Stack gap={4} className="mt-4">
      <Stack justify="between" align="center" gap={2} direction="horizontal">
        <Heading size="xl" weight="semibold">
          Golden Note & Facts
        </Heading>
        <Button onClick={handleAddNewFact} disabled={isCreating}>
          <Icon name="PlusCircle" size="auto" />
          Add New Fact
        </Button>
      </Stack>

      {loading ? (
        <Text>Loading facts...</Text>
      ) : facts.length === 0 ? (
        <div className="w-full rounded-md border p-4 text-center">
          <Text color="secondary" size="md">
            No facts have been added yet. Use the "Add New Fact" button to
            create facts about this appointment.
          </Text>
        </div>
      ) : (
        <Grid
          justify="center"
          gap={6}
          className="grid-cols-[6fr_4fr_2fr_100px]"
        >
          {facts.map((fact) => (
            <GoldenSummaryFactForm
              key={fact.id + fact.updatedAt}
              data={fact}
              onSaveRequested={handleFactUpdate}
              onDeleteRequested={handleFactDelete}
              isSubmitting={isUpdating || isDeleting}
            />
          ))}
        </Grid>
      )}
    </Stack>
  );
};

export default GoldenSummaryFactsList;
